import { render, staticRenderFns } from "./gskaobo.vue?vue&type=template&id=67107094&scoped=true"
import script from "./gskaobo.vue?vue&type=script&lang=js"
export * from "./gskaobo.vue?vue&type=script&lang=js"
import style0 from "./gskaobo.vue?vue&type=style&index=0&id=67107094&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67107094",
  null
  
)

export default component.exports